export const BUTTON_NAMES = {
  authorize: 'Авторизоваться',
  cancel: 'Отмена',
  signUp: 'Оформить подписку',
  continueWithoutRegistration: 'Продолжить без подписки',
  backToSingUpStart: 'Вернуться к началу',
  navigateToMyAccount: 'Перейти в Личный кабинет',
  navigateBack: 'Вернуться к работе',
  continueSignUp: 'Продолжить оформление',
  cancelSignUp: 'Отменить оформление',
  good: 'Понятно, спасибо',
  navigateToSections: 'Перейти к разделам',
  backToPayment: 'Вернуться к оплате',
  paymentResultActionButton: 'Вернуться к задачам'
};
